export default __webpack_public_path__ + "static/media/purpleAzure.0a0d2565.svg";